const it = {
    enter_code: "ID sessione",
    connect: "Collegare",
    check_your_internet_connection: "Controlla la tua connessione Internet.",
    network_error: "Errore di rete",
    server_error: "Errore del server",
    check_server_connection: "Errore interno del server",
    downtime: "Tempo morto",
    server_is_currently_facing_downtime: "Il server sta attualmente affrontando tempi di inattività",
    show_what_you_see: "Mostra quello che vedi",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "Confermo di aver letto e di accettare la politica sulla riservatezza.",
    privacy_policy: "politica sulla riservatezza",
    invalid_code: "ID sessione non valido",
    code_should_be_of_nine_digits: "L'ID sessione deve essere di 9 cifre",
    blitzz: "Blitzz",
    please_enter_your_name: "Per favore inserisci il tuo nome",
    maximum_value_is_30: "Il nome deve contenere meno di 30 caratteri.",
    please_enter_meeting_id: "Per favore inserisci il tuo CODICE",
    please_try_again: "Per favore riprova.",
    no_one_is_sharing_video: "Nessuno sta condividendo video.",
    retry: "Riprova",
    reconnect: "Riconnetti",
    left_the_conversation: "ha lasciato la conversazione",
    enabled_the_audio: "abilitato l'audio",
    disabled_the_audio: "disabilitato l'audio",
    enabled_the_video: "abilitato il video",
    disabled_the_video: "disabilitato il video",
    failed_to_join_room: "Impossibile entrare nella stanza",
    alert: "Mettere in guardia",
    override_video_sharing_message: "Vuoi terminare la condivisione dello schermo corrente e iniziare a condividere il tuo video?",
    override_screen_sharing_message: "Vuoi terminare l'attuale condivisione dello schermo e iniziare a condividere il tuo schermo?",
    override_video_sharing_with_screen_capturing_message: "Vuoi terminare il video corrente e iniziare a condividere il tuo schermo?",
    override_screen_sharing_with_video_sharing_message:
        "Vuoi terminare la condivisione dello schermo corrente e iniziare a condividere il tuo video?",
    yes: "sì",
    cancel: "Annulla",
    joined_the_call: "si è unito alla chiamata",
    waiting_for_other_members_to_join_the_call: "In attesa che altri membri si uniscano alla chiamata",
    warning: "avvertimento",
    camera_permission_disabled: "Impossibile accedere alla fotocamera.",
    microphone_permission_disabled: "Impossibile accedere al microfono.",
    location_permission_disabled: "Impossibile accedere alla posizione.",
    storage_permission_disabled: "Impossibile accedere allo spazio di archiviazione",
    permission_error_message_camera: "Abilita la fotocamera dalle impostazioni del dispositivo.",
    permission_error_message_microphone: "Abilita il microfono dalle impostazioni del dispositivo.",
    permission_location_error_message: "Abilita la posizione dalle impostazioni del dispositivo.",
    permission_storage_error_message: "Abilita l'archiviazione dalle impostazioni del dispositivo.",
    give_permission: "Dare il permesso",
    please_wait_for_five_seconds_to_take_screenshot: "Attendi 5 secondi per scattare un'altra foto",
    please_wait_for: "Per favore aspetta wait",
    seconds_to_take_screen_shot: "secondi per scattare un'altra foto.",
    second_to_take_screen_shot: "secondo per scattare un'altra foto.",
    invalid_information_received_from_server: "Informazioni non valide ricevute dal server.",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet:
        "Impossibile condividere il video perché nessun altro si è ancora unito alla conversazione",
    successfully_uploaded: "Caricato con successo",
    disconnected: "disconnesso",
    call_ended_as_no_one_else_had_joined_the_call: "Disconnesso perché nessun altro si è unito.",
    application_update_required: "Aggiornamento dell'applicazione richiesto",
    update_required_message: "Sembra che tu sia su una versione precedente dell'applicazione, aggiorna dall'app store.",
    update: "Aggiornare",
    image_marking_started: "Marcatura dell'immagine iniziata",
    image_marking_stopped: "Marcatura dell'immagine interrotta",
    settings: "impostazioni",
    camera_permission_rationale: "Abbiamo bisogno dell'accesso alla tua fotocamera. Si prega di dare il permesso alla fotocamera",
    microphone_permission_rationale: "Abbiamo bisogno dell'accesso al tuo microfono. Si prega di dare il permesso al microfono",
    location_permission_rationale: "Abbiamo bisogno di accedere alla tua posizione. Si prega di dare il permesso di posizione",
    storage_permission_rationale: "Abbiamo bisogno dell'accesso al tuo spazio di archiviazione. Si prega di dare il permesso di archiviazione",
    call_between_two_customers: "L'agente non si è unito, riprova tra qualche tempo.",
    media_projection_permission_needed_for_screen_sharing: "Permesso di proiezione multimediale necessario per la condivisione dello schermo.",
    poor_network_connection: "Avvertimento! Connessione di rete scadente",
    you_are_the_only_person_in_the_call: "Sei l'unica persona nella chiamata",
    image_has_been_captured_and_started_uploading: "L'immagine è stata acquisita e il caricamento è iniziato",
    version: "Versione",
    please_enter_the_code_provided_to_you: "Inserisci il CODICE che ti è stato fornito.",
    start_screen_share: "Condividere lo schermo",
    stop_screen_share: "Interrompi condivisione",
    flip_camera: "Flip Camera",
    take_photo: "Fare foto",
    flash_off: "Flash spento",
    flash_on: "Flash acceso",
    start_markup: "Avvia markup",
    stop_markup: "Interrompi markup",
    speaker_off: "Altoparlante disattivato",
    speaker_on: "Altoparlante attivato",
    more: "Di più",
    close: "Vicino",
    video_off: "Video OFF",
    video_on: "Video ON",
    start_video: "Avvia video",
    stop_video: "Interrompi video",
    disconnect: "Disconnetti",
    mute: "Muto",
    muted: "Riattiva",
    powered_by_blitzz: "Realizzato da Blitzz",
    connecting_your_call: "Collegato. In attesa di altri partecipanti.",
    connected: "Collegato",
    pin_is_of_nine_digit: "Il pin dovrebbe essere di 9 cifre",
    preparing_image_for_markup: "Preparazione dell'immagine per il markup...",
    clear_markup_confirmation: "Cancella i markup delle immagini da tutti gli utenti?",
    clear_markup: "Cancella markup",
    clear: "Chiaro",
    close_markup: "Chiudi markup",
    end_markup_confirmation: "Sei sicuro di voler chiudere il markup?",
    end: "Fine",
    agent_has_ended_markup_cannot_continue_without_agent: "L'agente ha terminato il markup. Impossibile continuare il markup senza agente",
    joining_image_markup: "Caricamento immagine per markup...",
    cleared_markup: "Markup immagine cancellati per tutti gli utenti.",
    capturing_photo: "Acquisizione foto...",
    uploading: "Caricamento",
    image: "Immagine",
    image_ready_for_markup: "Immagine pronta per il markup.",
    override_video: "Questo fermerà il video di altri. Vuoi continuare?",
    override_screen_share: "Questo interromperà la condivisione dello schermo di altri. Vuoi continuare?",
    started_screen_share: "Condivisione schermo avviata.",
    stopped_screen_share: "Condivisione schermo interrotta.",
    clear_all: "Cancella tutto",
    start_new_call_popup: "Inizia una nuova chiamata con CODE",
    group_call_limit_reached: "Limite di chiamate di gruppo raggiunto",
    contact_admin_to_increase_participant_limit: "Attendi che qualsiasi altro partecipante si disconnetta e poi riprova.",
    call_is_being_connected: "La chiamata è in corso, riprova più tardi.",
    show_recording_for_training_purpose: "Questa sessione è in fase di registrazione.",
    you_are_sharing_the_screen: "Stai condividendo lo schermo",
    location_colon: "Posizione:",
    date_colon: "Data:",
    image_for_markup_has_been_downloaded: "L'immagine per il markup è stata scaricata",
    dismiss: "Respingere",
    google_play_service_is_not_up_to_date: "Servizio Google Play non aggiornato",
    rec: "Rec",
    you_are_offline: "Sei offline.",
    markup: "markup",
    exit: "Uscita",
    video_unsupported: "Video non supportato",
    please_open_this_link_in_safari: "Si prega di aprire questo collegamento in Safari.",
    you_are_not_able_to_see_this_video: "Non riesci a vedere questo video.",
    only_number_Allowed: "Sono ammessi solo numeri.",
    permission_warning: "Avviso di autorizzazione",
    unable_to_join_call_please_try_after_sometime: "Impossibile partecipare alla chiamata. Si prega di provare dopo qualche tempo",
    share_live_video: "Condividi il tuo video in diretta?",
    share_your_screen: "Condividi il tuo schermo?",
    unable_access_flash: "Impossibile accedere a Flash Light.",
    camera_unavailable_try_again: "La fotocamera non è disponibile, riprova.",
    unable_download_image_tomarkup: "Impossibile scaricare l'immagine dal server, riprovare.",
    try_again: "Riprova",
    markup_screen_appear_shortly: "La schermata di markup apparirà a breve...",
    confirm: "Confermare",
    start: "Inizio",
    could_not_find_endpoint: "Impossibile trovare l'endpoint del server.",
    please_wait: "Attendere prego...",
    done: "Fatto",
    ok: "Ok",
    please_try_again_with_valid_agent_id: "Riprova con un ID agente valido.",
    meeting_code_not_associated_with_agent: "L'ID sessione non è associato a questo ID agente.",
    powered_by: "Offerto da",
    failure: "Fallimento",
    code: "ID sessione",
    start_new_call_question: "Inizia una nuova chiamata?",
    stop_sharing: "Basta condividere",
    reconnecting_call: "Riconnessione chiamata...",
    unable_to_access_mircrophone_or_camera: "Impossibile accedere al microfono o alla videocamera.",
    be_sure_to_allow_access_in_browser: "Assicurati di consentire l'accesso nelle impostazioni del browser.",
    make_sure_you_have_microphone_camera_attached: "Assicurati di avere una fotocamera o un microfono collegati.",
    location_blocked_by_user: "Posizione bloccata dall'utente",
    user_has_joined_the_call: "L'utente si è unito alla chiamata",
    are_you_sure_you_want_to_close_window: "Sei sicuro di voler chiudere questa finestra?",
    reset_guide: "Guida al ripristino",
    open_in_google_maps: "Apri in Google Maps",
    location_image_upload_failed: "Caricamento dell'immagine della posizione non riuscito",
    uploading_image: "Caricamento immagine",
    upload_failed: "Caricamento fallito",
    markup_is_in_progress: "Il markup è in corso...",
    select_language: "Seleziona la lingua",
    checking_for_extension: "Verifica dell'estensione...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "Per avviare la condivisione dello schermo in modalità di navigazione in incognito devi avviare la modalità di navigazione in incognito da Blitzz - Estensione Screen Share del tuo browser.",
    click_on: "Clicca su",
    customize_and_control_menu: "Personalizza e controlla il menu",
    more_tools: "Altri strumenti",
    extensions: "Estensioni",
    click_on_detail: "Clicca sui dettagli (Blitzz)",
    allow_in_incognito: "Consenti in incognito.",
    screen_share: "Condivisione schermo",
    stop_share: "Interrompi condivisione",
    save: "Salva",
    cancel_initcap: "Annulla",
    yes_initcap: "sì",
    message_title: "Messaggio",
    device_not_compatible: "Spiacenti, questo dispositivo non è compatibile.",
    please_download_our_app: "Scarica la nostra app per continuare.",
    download_app: "Scarica l'app",
    this_browser_is_not_supported: "Questo browser non è attualmente supportato.",
    open_in_chrome_or_install_mobile_app:
        "Copia e incolla questo link nell'ultima versione di Google Chrome o installa la nostra app mobile e riprova.",
    open_in_safari_or_install_mobile_app:
        "Copia e incolla questo collegamento nell'ultima versione del browser Safari o installa la nostra app mobile e riprova.",
    open_in_chrome_and_try_again: "Apri questo link nell'ultima versione di Google Chrome e riprova.",
    okay_initcap: "Va bene",
    would_you_like_to_install_app_or_continue_browser: "Vuoi installare la nostra App per partecipare al Meeting o Continuare con il browser?",
    continue_initcap: "Continua",
    webview_limited_support_message: "Per un'esperienza ottimale, apri il browser Chrome o il browser predefinito.",
    continue_anyway: "Continua comunque",
    open_in_browser: "Apri nel browser",
    link_copied_open_in_browser: "Link copiato! Se il browser non si apre, incolla il link in Chrome.",
    add_blitzz_extension_to_screen_share: "Aggiungi l'estensione Blitzz alla condivisione dello schermo",
    add_to_chrome_and_confirm: '"Aggiungi a Chrome e conferma"',
    add_extension: "Aggiungi estensione",
    permission_error_message_camera_browser: "Si prega di abilitare la fotocamera dalle impostazioni del browser.",
    camera_not_found: "Fotocamera non trovata",
    enable_camera_and_reconnect_call: "Devi abilitare la videocamera, ricaricare la pagina e riconnettere la chiamata.",
    permission_error_message_microphone_browser: "Abilita il microfono dalle impostazioni del browser.",
    microphone_not_found: "Microfono non trovato",
    enable_microphone_and_reconnect_call: "Devi abilitare il microfono, ricaricare la pagina e riconnettere la chiamata.",
    download_failed: "Scaricamento fallito",
    continue_markup: "Continua markup",
    save_and_exit: "Salva ed esci da markup",
    exit_markup: "Esci da markup",
    you_are_recording_the_conversation: "Ora stai registrando la conversazione.",
    make_sure_participant_know_they_are_being_recorded: "Assicurati che i partecipanti sappiano che vengono registrati.",
    you_can_download_recordings_later: "È possibile scaricare il file registrato in seguito.",
    share_without_joining_session_lanuch_showme_enter_code:
        "Impossibile condividere lo schermo senza partecipare a una sessione ShowMe. Avvia ShowMe by Blitzz e inserisci il CODICE che ti è stato fornito.",
    call_limit_reach_contact_Admin_to_increase_limit:
        "Limite di chiamate di gruppo raggiunto. Contatta il tuo amministratore per aumentare il limite di partecipanti o attendi che un membro lasci la sessione.",
    other_user_trying_share_screen_Video: "Un altro utente sta tentando di condividere lo schermo o il video",
    call_has_ended: "La chiamata è terminata",
    would_you_like_to_save_image: "Vuoi salvare l'immagine?",
    audio_unsupported: "Audio non supportato",
    please_install_our_app_to_continue: "Installa la nostra app per continuare.",
    unable_to_play_remote_audio: "Impossibile riprodurre l'audio remoto.",
    unable_to_playback_audio: "Impossibile riprodurre l'audio.",
    unable_to_play_video: "Impossibile riprodurre il video.",
    unable_to_playback_video: "Impossibile riprodurre il video.",
    okay_cap: "Va bene",
    pre_call_test: "Test pre-chiamata",
    language: "linguaggio",
    reset: "Ripristina",
    zoom_in: "Ingrandire",
    zoom_out: "Rimpicciolisci",
    headset: "Auricolare",
    bluetooth: "Bluetooth",
    live_pointer_enabled_message: "Puntatore live avviato. Puoi spostare il puntatore trascinandolo.",
    speaker: "Altoparlante",
    live_pointer_disabled_message: "Puntatore live interrotto",
    pointer: "puntatore",
    network_quality: "Qualità della rete",
    participant: "Partecipante",
    you: "(Voi)",
    reconnecting: "Riconnessione",
    very_bad: "Molto brutto",
    bad: "Cattivo",
    poor: "Povero",
    good: "Buona",
    excellent: "Eccellente",
    loc: "posizione",
    expand: "Espandere",
    collapse: "Crollo",
    network: "Rete",
    ocr_inprogress: "L'OCR è in corso...",
    select_area_extract_text: "Seleziona l'area per estrarre il testo",
    text_copied: "Testo copiato",
    extract_text_from_image: "Estrazione del testo dall'immagine...",
    not_extract_text_from_image: "Impossibile estrarre il testo dall'immagine.",
    try_again_clear_image_or_reselect_region: "Riprova con un'immagine chiara o riseleziona la regione di estrazione.",
    error: "Errore",
    occured_while_receiving_doc: "verificato durante la ricezione del documento.",
    return_to_video: "Torna al video",
    save_entire_image: "Salva Intero",
    save_cropped_image: "Salva ritagliato",
    text_copied_to_clipboard: "Clicca per copiare",
    extract_text: "Estrai testo",
    stop_pointer: "Interrompi puntatore",
    reference: "Riferimento",
    do_not_rotate_the_phone_live_pointer_message:
        "Per una migliore esperienza visiva, non ruotare il dispositivo mentre il puntatore live è abilitato.",
    got_it_btn: "Fatto!",
    email: "E-mail",
    mobile_number: "Numero di cellulare",
    speed_test: "Test di velocità",
    duration: "Durata",
    preparing_image_for_OCR: "Preparazione dell'immagine per l'elaborazione del testo...",
    agent_extract_text_from_image: "Attendere, l'agente sta estraendo il testo dall'immagine acquisita.",
    unable_download_image_to_ocr: "Impossibile scaricare l'immagine per l'elaborazione. Riprova.",
    selected_area_is_small: "L'area selezionata è troppo piccola,",
    please_select_large_area: "si prega di selezionare un'ampia area dell'immagine.",
    zoom_level: "Livello di zoom",
    do_not_rotate_the_phone_markup_message:
        "Per una migliore esperienza di visualizzazione, non ruotare il dispositivo mentre il markup è abilitato.",
    uploaded_images: "Immagini caricate",
    upload_completed: "Caricamento completato",
    capturing: "Cattura...",
    network_quality_not_available: "Qualità della rete non disponibile",
    not_able_to_see_your_stream: "non sarà in grado di vedere il tuo stream",
    device_not_supported: "Dispositivo non supportato.",
    video_settings_need_to_be_configured_by_admin_web:
        "Le impostazioni video devono essere configurate dall'amministratore per supportare questo dispositivo. Si prega di contattare l'amministratore dell'azienda o inviare un'e-mail",
    contact: "Contatto",
    video_paused_by_agent: "Video messo in pausa dall'agente",
    screenshare_paused_by_agent: "Condivisione schermo messa in pausa dall'agente",
    not_shared: "Non condiviso",
    permission_error_message_location_browser: "Si prega di abilitare la posizione dalle impostazioni del browser.",
    network_type: "Tipo di rete",
    update_your_browser_to_share_your_screen: "Aggiorna il tuo browser all'ultima versione per condividere il tuo schermo",
    image_thumb_caption: "Immagine",
    saved_images: "Immagini salvate",
    try_these_option_to_have_better_experience: "Prova una di queste opzioni per un'esperienza migliore.",
    some_features_are_not_supported_in_this_browser: "Alcune funzionalità non sono supportate in questo browser.",
    unsupported_browser: "Browser non supportato",
    permission_message_for_screenshare:
        "Le autorizzazioni per accedere all'area dello schermo sono state negate o l'istanza del browser corrente non dispone delle autorizzazioni per accedere alla condivisione dello schermo.",
    go_to_system_preferences: "Vai a Preferenze di Sistema",
    security_privacy: "Sicurezza e privacy",
    select_privacy_tab: "Seleziona la scheda Privacy",
    screen_recording: "Registrazione dello schermo",
    select_google_chrome: "Seleziona Google Chrome",
    use_chrome_to_share_your_screen: "Usa il browser Chrome o Firefox per condividere il tuo schermo",
    agree: "Essere d'accordo",
    decline: "Declino",
    there_was_an_error_trying_to_share_your_video: "Si è verificato un errore durante il tentativo di condividere il tuo video.",
    please_stop_video_and_start_video_again_to_resume: "Interrompi il video e riavvia il video per riprenderlo.",
    click_the_padlock: "Fare clic sul lucchetto",
    to_the_left_of_a_web_page_address: "a sinistra della barra degli indirizzi.",
    clear_blocked_permission_for_share_the_screen:
        "Cancella tutte le autorizzazioni di condivisione dello schermo bloccate nella sezione delle autorizzazioni.",
    select_your_browser: "Seleziona il tuo browser",
    tips_colon: "Suggerimenti:",
    your_internet_connection_is_unstable: "La tua connessione Internet è instabile",
    participants_connection_unstable: "La connessione Internet del <participantNum>",
    draw: "Disegnare",
    rect: "Rett",
    text: "Testo",
    enter_text_here: "Inserisci il testo qui",
    showme_app_found: "App ShowMe trovata",
    use_showme_app: "Usa l'app ShowMe",
    showme_app_for_guest_user:
        "Abbiamo rilevato un'app ShowMe leggera per gli utenti Guest su questo dispositivo. Questa app non ha funzionalità avanzate. Si prega di disinstallare l'app e quindi riconnettersi per continuare a utilizzare il browser.",
    participants_title: "partecipanti",
    bookmarks_title: "segnalibri",
    search_or_add_new_bookmark: "Cerca o aggiungi un nuovo segnalibro",
    create_new_bookmark: "Crea nuovo segnalibro",
    press_enter_or_click_on_create_new_bookmark: "Premi Invio o fai clic su Crea nuovo segnalibro per aggiungere un nuovo segnalibro",
    tap_retry_to_load: "Tocca Riprova per caricare",
    bookmark_saved_with_image: "Segnalibro salvato con immagine.",
    bookmark_saved: "Segnalibro salvato.",
    failed_to_bookmark_please_try_again: "Impossibile aggiungere un segnalibro. Per favore riprova.",
    try_our_mobile_app: "Apri nell'app",
    still_facing_issue_connect_mobile_app: "Se stai ancora riscontrando un problema, connettiti utilizzando la nostra app mobile.",
    open_in_app: "Apri nell'app",
    enable_microphone_from_browser_settings: "Abilita il microfono dalle impostazioni del browser.",
    enable_camera_from_browser_settings: "Abilita la fotocamera dalle impostazioni del browser.",
    unable_to_access_microphone: "Impossibile accedere al microfono",
    special_characters_are_not_allowed: "Non sono ammessi caratteri speciali.",
    home_screen: "Schermo di casa",
    bookmark_added: "Segnalibro aggiunto.",
    privacy_policy_popup_text_description:
        "Comprendo e accetto di utilizzare volontariamente la mia fotocamera per condividere una visione di ciò che mi circonda per risolvere i problemi tecnici che sto riscontrando. Comprendo che nessuna registrazione verrà effettuata o archiviata. Posso disattivare la funzione di condivisione in qualsiasi momento. Non punterò la fotocamera su aree, individui o oggetti la cui immagine non desidero condividere. Confermo inoltre di aver letto e accettato la Privacy Policy.",
    allow_access_to_location: "Consenti l'accesso alla posizione",
    allow_access_to_location_description: "Consenti l'accesso alla tua posizione nel popup successivo per convalidare la tua posizione.",
    ok_i_understand: "Ok ho capito",
    allow_microphone_access: "Consenti l'accesso al microfono",
    allow_microphone_access_description: "Consenti l'accesso al tuo microfono in modo che gli altri partecipanti possano sentirti.",
    allow_camera_access: "Consenti l'accesso alla fotocamera",
    allow_camera_access_description: "Consenti l'accesso alla tua fotocamera nel popup successivo.",
    allow_bluetooth_access: "Consenti l'accesso Bluetooth",
    allow_bluetooth_access_description: "Consenti l'accesso al tuo Bluetooth per passare da una sorgente audio all'altra.",
    permission_error_message_for_camera:
        "Errore di autorizzazione: non abbiamo accesso alla tua fotocamera. Vai su Impostazioni e Abilita l'autorizzazione della fotocamera. Ciò disconnetterà la chiamata in corso. Puoi riconnetterti avviando nuovamente l'app.",
    permission_error_message_for_microphone:
        "Errore di autorizzazione: non abbiamo accesso al tuo microfono. Vai su Impostazioni e Abilita l'autorizzazione del microfono. Ciò disconnetterà la chiamata in corso. Puoi riconnetterti avviando nuovamente l'app.",
    permission_error_message_for_location:
        "Errore di autorizzazione: non abbiamo accesso alla tua posizione. Vai su Impostazioni e Abilita l'autorizzazione alla posizione. Ciò disconnetterà la chiamata in corso. Puoi riconnetterti avviando nuovamente l'app.",
    enable_microphone: "Abilita microfono",
    enable_camera: "Abilita fotocamera",
    enable_location: "Abilita posizione",
    enable_bluetooth: "Abilita Bluetooth",
    audio_issue_ios: "Problema audio?",
    toggle_mic_icon_guest_msg: "Attiva o disattiva l'icona rossa del microfono/cam sopra o usa l'audio dalla telefonata. (PSTN)",
    toggle_mic_icon_agent_msg:
        "Richiedi all'utente iOS di attivare/disattivare l'icona rossa del microfono/cam in alto o di utilizzare l'audio della chiamata telefonica. (PSTN)",
    audio_ios_msg_read_more: "Leggi di più",
    error_occured_in_processing_the_request: "Si è verificato un errore durante l'elaborazione della richiesta. Per favore riprova.",
    markup_ocr_upload_timeout: "Ci vuole più tempo del solito.",
    markup_cancelled: "Markup annullato",
    ocr_cancelled: "Estrai testo annullato",
    click_here: "Clicca qui",
    to_return_to_video_and_try_again: "per tornare a Video e riprovare.",
    markup_exit: "ha interrotto il markup",
    ocr_exit: "interrotto Estrai testo",
    camera: "telecamera",
    camera_blocked: "Fotocamera bloccata",
    microphone: "Microfono",
    microphone_blocked: "Microfono bloccato",
    speakers: "Altoparlanti",
    speakers_blocked: "Altoparlanti bloccati",
    grant_permission: "Concedere l'autorizzazione",
    play_test_sound: "Riproduci suono di prova",
    call_settings: "Impostazioni di chiamata",
    allow_access_to_camera: "Consenti l'accesso alla tua fotocamera.",
    allow_access_to_mic: "Consenti l'accesso al tuo microfono.",
    default_label: "Predefinito",
    do_not_rotate_the_phone_OCR_message:
        "Per una migliore esperienza di visualizzazione, non ruotare il dispositivo mentre Estrai testo è abilitato.",
    test_connection: "Connessione di prova",
    browser_not_supported: "Browser non supportato",
    your_browser_not_support_video: "Il tuo browser non supporta le videochiamate.",
    open_link_in_google_samsung_browser: "Copia e incolla questo link nell'ultima versione di Google Chrome o del browser Internet Samsung.",
    open_link_in_safari_browser: "Si prega di copiare e incollare questo collegamento nell'ultima versione del browser Safari.",
    copy_link: "Copia link",
    copy_code: "Copia codice",
    guest_url_copy: "URL ospite copiato negli appunti.",
    session_code_copy: "ID sessione copiato negli appunti.",
    meeting_code_lable: "Codice riunione",
    add_participant_lable: "Aggiungi partecipante",
    send_this_link_to_guest: "Invia questo link all'ospite",
    send_an_email: "invia una mail",
    or_label: "o",
    remote_mic_cam_error: "Il microfono/fotocamera del partecipante remoto ha un errore.",
    device_not_supported_or_permi_block: "O il loro dispositivo non è supportato o hanno le autorizzazioni bloccate.",
    remote_participant: "Partecipante remoto",
    microphone_unmuted: "Microfono disattivato",
    microphone_muted: "Microfono disattivato",
    camera_on: "Fotocamera accesa",
    camera_off: "Fotocamera spenta",
    earpiece: "Auricolare",
    error_label: "errore",
    cannot_start_video: "Impossibile avviare il video",
    failed_to_start_video_camera: "Impossibile avviare la videocamera.",
    please_select_another_camera_from_call_settings: "Seleziona un'altra videocamera da Impostazioni chiamata.",
    please_select_another_video_camera: "Seleziona un'altra videocamera.",
    chat: "Chiacchierare",
    chat_info:
        "I messaggi di chat sono visibili a tutti i partecipanti alla chiamata. La cronologia chat scomparirà in modo permanente quando ti disconnetti, in base alla progettazione.",
    chat_input_placeholder: "Scrivi un messaggio",
    participant_connected: "<participantCount> partecipanti connessi",
    click_to_share_invite: "Fai clic per condividere l'invito",
    remote_flashlight_not_supported_on_guest_device_or_not_ready: "Torcia remota non supportata sul dispositivo ospite o non pronta",
    pin_a_video_tile_above_to_use_this_feature: "Appunta un riquadro video sopra per utilizzare questa funzione",
    pin_video_for_all_participants: "Pin video per tutti i partecipanti",
    return_to_gallery_view: "Torna alla visualizzazione della galleria",
    override_own_screen_share: "La condivisione dello schermo verrà interrotta. Vuoi continuare?",
    override_own_video: "Il tuo video verrà interrotto. Vuoi continuare?",
    you_have_started_the_video: "Hai iniziato il video",
    back_lable: "indietro",
    front_lable: "davanti",
    blur: "sfocatura",
    mask_lable: "Maschera",
    view_text: "Visualizza",
    stop_label: "Fermare",
    recording_stopped: "Registrazione interrotta",
    error_recording_please_try_again: "Errore di registrazione, riprovare",
    error_recording_wait_or_disconnect_call:
        "Errore di registrazione. Attendi che l'host interrompa la registrazione oppure puoi disconnetterti e rientrare in un secondo momento.",
    wait_for_recording: "Si prega di attendere mentre si avvia la registrazione...",
    max_participant_limit_for_recording:
        "massimo limite di partecipanti raggiunto durante la registrazione. Attendi che l'host interrompa la registrazione oppure puoi disconnetterti e rientrare in un secondo momento.",
    start_recording: "La registrazione è stata avviata.",
    stop_recording: "La registrazione è stata interrotta.",
    arrow: "Freccia",
    error_recording_all_participants: "Errore durante la registrazione di tutti i partecipanti.",
    please_stop_and_restart_recording: "Interrompi e riavvia la registrazione.",
    some_participants_will_not_be_recorded: "Alcuni partecipanti non verranno registrati.",
    participant_limit_reached: "Limite partecipanti raggiunto.",
    your_account_has_4_participant_limit_while_recording: "Il tuo account ha un limite di 4 partecipanti durante la registrazione.",
    disconnect_call: "Disconnetti chiamata",
    record_title: "Disco",
    stop_recording_btn: "Interrompi registrazione",
    back_to: "Torna a",
    remind_me_later: "Ricordamelo più tardi",
    skip_this_update: "Salta questo aggiornamento",
    cam_per_denied_msg:
        "Uno dei tuoi partecipanti potrebbe aver bloccato l'accesso alla fotocamera sul proprio dispositivo. Per guidarli, si prega di visualizzare",
    mic_per_denied_msg:
        "Uno dei tuoi partecipanti potrebbe aver bloccato l'accesso al microfono sul proprio dispositivo. Per guidarli, si prega di visualizzare",
    cam_mic_per_denied_msg:
        "Uno dei partecipanti potrebbe aver bloccato l'accesso alla fotocamera e al microfono sul proprio dispositivo. Per guidarli, si prega di visualizzare",
    your_camera_block: "La tua fotocamera è bloccata",
    your_microphone_block: "Il tuo microfono è bloccato",
    your_location_block: "La tua posizione è bloccata",
    we_cannot_access_your_camera: "Non possiamo accedere alla tua fotocamera.",
    we_cannot_access_your_microphone: "Non possiamo accedere al tuo microfono.",
    we_cannot_access_your_location: "Non possiamo accedere alla tua posizione.",
    go_to_browser_settings: "Per dare l'accesso, vai alle impostazioni del tuo browser e poi clicca qui per ricaricare la pagina.",
    still_facing_issue: "Hai ancora problemi?",
    try_the: "Prova il",
    mobile_app: "app mobile",
    view_help_article: "Visualizza l'articolo della guida",
    enable_or_attach_camera_and_reconnect_call: "È necessario abilitare o collegare la telecamera, ricaricare la pagina e riconnettere la chiamata.",
    enable_or_attach_microphone_and_reconnect_call:
        "È necessario abilitare o collegare il microfono, ricaricare la pagina e riconnettere la chiamata.",
    per_denied_common_msg: "per suggerimenti rapidi per ripristinare le autorizzazioni del browser.",
    start_rec_label: "Avvia registrazione",
    stop_rec_label: "Interrompi registrazione",
    start_recording_tooltip_label: "Inizia a registrare",
    cam_per_denied_title: "Fotocamera del partecipante remoto bloccata",
    mic_per_denied_title: "Microfono partecipante remoto bloccato",
    cam_mic_per_denied_title: "Fotocamera e microfono del partecipante remoto bloccati",
    these_instructions: "queste istruzioni",
    click_here_label: "clicca qui",
    from_participant: "Dal partecipante",
    download_key: "Scarica",
    download_not_supported_text: "Il download non è supportato sul tuo dispositivo.",
    undo: "Disfare",
    redo: "Rifare",
    fill: "Riempire",
    Whisper_on: "Sussurro acceso",
    Whisper_off: "Sussurro spento",
    enable_whisper_tooltip_label: "Abilita il sussurro per parlare con l'host",
    host_can_hear_you_now: "L'host può sentirti ora",
    mediate_lable: "Mediare",
    join_call_as_participant: "Partecipa alla chiamata come partecipante",
    observer_lable: "Osservatore",
    silent_observer_connect_alert_popup: "Connesso come osservatore. Il tuo microfono e la tua telecamera sono disattivati.",
    click_mediate_if_you_would_like_to_join_as_a_participant: 'Clicca su "Media" se vuoi partecipare.',
    Silent_observer_lable: "Osservatore silenzioso",
    invite_participant_tooltip_lable:
        "Il microfono e la videocamera saranno disattivati per Silent Observer e non saranno visibili ai partecipanti ospiti.",
    send_link_silent_observer: "Invia questo link all'osservatore silenzioso.",
    join_as_mediator_title: "Partecipa come mediatore?",
    join_as_mediator_popup_description:
        "Sei sicuro di voler partecipare alla chiamata come partecipante? Fare clic su Conferma di seguito, quindi fare clic su Connetti nella schermata successiva per partecipare come partecipante (mediatore).",
    guest_lable: "ospite",
    overall_experience: "Esperienza complessiva?",
    leave_comment: "Lascia un commento (facoltativo)",
    sent: "Inviato",
    send: "Spedire",
    color_label: "Colore",
    view_unavailable: "Visualizza non disponibile",
    thanks: "Grazie!",
    whisper_label: "Sussurro",
    stop_recording_tooltip_label: "Torna alla modalità galleria per interrompere la registrazione.",
    save_image: "Salva immagine",
    screenshare_mweb_text: "La condivisione dello schermo dal tuo dispositivo richiede un'app. Connetti questa sessione dall'app mobile.",
    disconnect_and_launchapp_btn: "Disconnetti e avvia l'app",
    device_battery_low: "Batteria del dispositivo scarica",
    notes_lable: "Appunti",
    new_note_lable: "Nuova nota",
    only_visible_to_you: "Visibile solo a te",
    empty_note: "Nota vuota",
    title_lable: "Titolo",
    delete_lable: "Elimina",
    delete_Note: "Elimina nota",
    want_delete_this_note: "Sei sicuro di voler eliminare questa nota?",
    failed_delete_note: "Impossibile eliminare la nota.",
    note_deleted_successfully: "Nota cancellata",
    failed_edit_note: "Impossibile modificare la nota.",
    note_edited_successfully: "Nota aggiornata",
    failed_add_note: "Impossibile aggiungere la nota.",
    note_added_successfully: "Nota aggiunta",
    batteryinfo_tooltip: "Informazioni sulla batteria del dispositivo",
    screenshare_mweb_title: "Download dell'app richiesto",
    screenshare_mweb_desc1: "La condivisione dello schermo dal tuo dispositivo richiede un'app.",
    screenshare_mweb_desc2: "per scaricare l'applicazione.",
    upcoming_event: "Prossimo evento",
    scheduled_to_start_in: "Previsto per iniziare in",
    please_wait_for_the_host_to_start_this_event: "Attendi che l'organizzatore avvii questo evento e riprova.",
    image_deleted: "Immagine eliminata",
    failed_to_delete_image: "Impossibile eliminare l'immagine",
    are_you_sure_you_want_to_delete_image: "Sei sicuro di voler eliminare definitivamente questa immagine?",
    delete_image_title: "Elimina immagine",
    sms_sent_label: "SMS inviato!",
    whatsapp_sent_label: "Invito WhatsApp inviato!",
    whatsapp_label: "WhatsApp",
    email_sent_label: "Email inviata!",
    smartglass_sent_label: "Invito Smartglass inviato!",
    schedule_to_start_in_a_few_seconds: "Programmato per iniziare in pochi secondi.",
    location_image_thumb_caption: "Immagine posizione",
    updated_successfully: "Aggiornato con successo",
    edit_label: "modificare",
    scan_code_lable: "Scansione codice",
    scan_code_result: "Risultato del codice di scansione",
    extract_text_result: "Estrai il risultato del testo",
    scan_code_result_not_found: "Impossibile eseguire la scansione del codice QR/codice a barre dall'immagine. Riprova con un'immagine chiara.",
    host_features_will_not_be_available_when_using_app: "Le funzionalità dell'host non saranno disponibili quando si utilizza l'app",
    note_colon: "Nota:",
    leave_lable: "Partire",
    are_you_sure_you_want_to_leave_this_call: "Sei sicuro di voler lasciare questa chiamata?",
    supported_browser_versions: "Versioni del browser supportate",
    see: "Vedere",
    call_disconnected: "Chiamata disconnessa",
    video_quality: "Qualità video",
    low_bandwidth: "Bassa larghezza di banda",
    adaptive: "Adattivo",
    high_quality: "Alta qualità",
    wait_for_the_call_to_start: "Attendi l'inizio della chiamata",
    enter_email_send: "Inserisci l'e-mail per inviare un invito",
    send_invitaion_lable: "Spedire un invito",
    enter_mobile_number_lable: "Inserisci il numero di cellulare",
    enter_valid_mobile: "Inserisci un numero di telefono valido.",
    dont_show_this_again: "Non mostrarlo più",
    share_invitation_with_others: "Condividi l'invito alla sessione con altri",
    new_email_address: "Indirizzo e-mail",
    invite_participant_lable: "Invita partecipante",
    saved_label: "Salvato!",
    show_stream: "Mostrare",
    hide_stream: "Nascondere",
    has_sent_you_link_for_video_conference: "<company_name> ha inviato un link per la videoconferenza dal vivo.",
    copy_invitation: "Copia l'invito alla sessione",
    copy_invitation_desc: "Copia il testo dell'invito con l'orario programmato e invialo manualmente",
    copied: "copiato!",
    copy_session_code: "Copia ID sessione",
    copy_link_to_share: "Copia il link per condividere",
    session_invitation_copied: "Invito alla sessione copiato negli appunti.",
    observer_url_copied: "URL osservatore copiato negli appunti.",
    invite_sent_successfully: "Invito inviato con successo",
    sms_label: "SMS",
    copy: "copia",
    enter_valid_email: "Inserisci un indirizzo email valido.",
    limit_exceeded: "Limite superato",
    other: "Altro",
    join_the_session: "Partecipa alla sessione",
    camera_permission_required_title: "È richiesta l'autorizzazione della fotocamera",
    camera_permission_required_disc1:
        "Per condividere video in diretta, attiva l'autorizzazione della fotocamera nelle impostazioni del browser, quindi",
    reload_page_disc: "per ricaricare la pagina.",
    location_permission_required_title: "Permesso di posizione richiesto",
    microphone_permission_required_title: "È richiesta l'autorizzazione del microfono",
    confirmation_lable: "Confermo di aver letto e di accettare le",
    live_location: "Posizione dal vivo",
    no_one_shared_location: "Nessuno ha condiviso la sua posizione",
    it_was_great_lable: "È stato fantastico",
    not_so_great_lable: "Non così eccezionale",
    link_copied: "Link copiato",
    whats_new: "Cosa c'è di nuovo",
    microphone_publication_description: "Microfono non trovato o potrebbe essere utilizzato da un'altra applicazione.",
    please_close_all_other_application: "Chiudi tutte le altre applicazioni che potrebbero utilizzare il microfono e riprova.",
    app_to_share_your_device_screen: "Continua questa chiamata nell'app per condividere lo schermo del tuo dispositivo",
    launch_app: "Avvia l'app",
    screen_share_requires_app: "La condivisione dello schermo richiede un'app.",
    only_takes_few_seconds: "Questo richiede solo pochi secondi.",
    download_app_from_app_store_and_then_return_page: "Scarica l'App dall'App Store e poi torna a questa pagina.",
    click_to_download_app: "Fare clic per scaricare l'app",
    go_to_Step_2: "Se hai già scaricato l'app, vai al passaggio 2",
    next_lable: "Il prossimo",
    rejoin_the_call_in_app: "Riconnettiti alla chiamata in App",
    step2_screen_share_description:
        "Dopo aver scaricato l'app, puoi partecipare di nuovo a questa chiamata nell'app e selezionare \"Condividi schermo\" per condividere lo schermo del tuo cellulare.",
    disconnect_the_call_in_browser: "Questo disconnetterà la chiamata nel browser",
    back_btn_lable: "Indietro",
    rejoin_call_in_app: "Riconnettiti alla chiamata nell'app",
    step_one: "Passo 1",
    step_two: "Passo 2",
    beta_release_tag_des1: "Questa funzione è attualmente in versione Beta.",
    email_support_feedback: "Invia un'e-mail a support@blitzz.co per condividere il tuo feedback.",
    would_you_like_to_exit_markup: "Vuoi uscire dal markup?",
    current_position: "Posizione attuale",
    start_point: "Punto di partenza",
    live_captions: "Didascalie dal vivo",
    starting_label: "Di partenza...",
    live_captions_started: "Didascalie dal vivo iniziate.",
    spoken_language_is_set_to_english: "La lingua parlata è impostata sull'inglese.",
    click_to_open_more_information: "Clicca per aprire maggiori informazioni",
    open_in_safari_chrome_or_install_mobile_app:
        "Copia e incolla questo link nell'ultima versione di Safari o del browser Google Chrome oppure installa la nostra app mobile e riprova.",
    continue_without_name: "Continua senza nome",
    enter_your_name: "Inserisci il tuo nome",
    ignore: "Ignorare",
    screen_share_info:
        "Per evitare uno specchio infinito, non condividere l'intero schermo o la finestra del browser. Condividi invece solo una scheda o una finestra diversa.",
    screen_share_to_everyone: "Stai condividendo lo schermo con tutti",
    stop_share_screen: "Interrompi la condivisione dello schermo",
    unable_to_start_the_video_please_download_the_app_to_continue: "Impossibile avviare il video, scarica l'app per continuare.",
    upload: "Caricamento",
    from_device: "Dal dispositivo",
    from_camera: "Dalla fotocamera",
    upload_failed_files: "Carica file non riusciti",
    uploaded_max_file: "Hai caricato il numero massimo di file consentito.",
    upload_files: "Caricare files",
    upload_limit_reached: "Limite di caricamento raggiunto",
    drop_for_upload_or_select: "Trascina qui per caricare o seleziona",
    upload_20_file: "Carica fino a 20 file alla volta.",
    max_size_20MB: "Massimo dimensione del file <fileSize> MB.",
    cancel_upload: "Annulla caricamento",
    cancel_upload_alert: "Annulla caricamento?",
    file_details_deleted: "Tutti i dettagli aggiunti ai tuoi file verranno eliminati.",
    uploaded_files: "File caricati",
    capture_image: "Cattura immagine",
    participant_uploading_file_msg: "Attendi mentre l'altro partecipante sta caricando i file.",
    previous: "Precedente",
    max_file_count: "Puoi caricare un massimo di file <fileCount> alla volta.",
    removed_more_than_20MB_file: "I file di dimensioni superiori a <fileSize> MB vengono rimossi.",
    uploading_files: "Caricamento di file",
    upload_failed_file_count: "Caricamento non riuscito: i file <numberOfFailedFiles> non sono stati caricati.",
    add_caption: "Aggiungi didascalia...",
    uploaded_files_of_a_maximum: "<successCount> , di un massimo <totalCount>",
    you_have_selected_the_maximum_number_of_files_allowed: "Hai selezionato il numero massimo di file consentito.",
    upload_max_count: "Carica il/i massimo/i file <remainingCount> .",
    image_upload_msg: "Attendi il caricamento delle immagini",
    finished_uploading: "Caricamento terminato",
    upload_files_msg: "Caricare files",
    uploading_dots: "Caricamento in corso...",
    loading_image_counter: "Caricamento dell'immagine <counter> di <totalCount>",
    closing_tab: "Scheda di chiusura",
    close_tab: "Chiudi scheda",
    return_to_home_screen: "Tornando alla schermata iniziale",
    session_code_expire_msg: "Questo collegamento è stato chiuso",
    view_call_logs: "Visualizza i registri delle chiamate",
    measurements: "Misure",
    copy_all: "Copia tutto",
    measure: "Misurare",
    view_supported_device: "Visualizza i dispositivi supportati",
    device_not_support_google_play_service: "Il dispositivo del partecipante non supporta Google Play Service, necessario per le misurazioni 3D",
    device_not_compatible_for_measurement: "Dispositivo non compatibile per la misurazione",
    device_required_update_google_play_service:
        "Il dispositivo del partecipante richiede l'aggiornamento di Google Play Service per avviare la misurazione 3D.",
    device_required_google_play_service:
        "Il dispositivo del partecipante richiede l'installazione di Google Play Service per avviare la misurazione 3D",
    app_required_update_for_measurement: "Aggiornamento dell'app di supporto richiesto per la misurazione",
    app_required_for_measurement: "App di supporto richiesta per la misurazione",
    preparing_ar_measurement: "Preparazione della vista per la misurazione...",
    measurement_copied_msg: "Misure copiate negli appunti",
    ready_for_measurement: "Pronto per la misurazione",
    move_device_to_start: "Sposta il dispositivo per iniziare",
    tacking_not_available: "Il monitoraggio non è disponibile",
    camera_use_bu_another_app: "La fotocamera è utilizzata da un'altra app",
    more_light_required: "Più luce richiesta",
    move_further_away: "Spostati più lontano",
    slow_down: "Rallentare",
    measurement_cancelled: "Misurazione annullata",
    app_required: "Questa funzione richiede il download dell'app. <learnmore>",
    learn_more: "Scopri di più",
    ar_measurement_description_step2:
        "Dopo aver scaricato l'app, puoi partecipare nuovamente a questa chiamata nell'app e selezionare \"Misura\" per avviare la misurazione AR",
    ar_measurement_description_step1:
        "La funzione di misurazione della realtà aumentata consente di misurare oggetti in 3D e richiede il download dell'app",
    app_to_support_ar_measurement: "Continua questa chiamata nell'app per supportare la misurazione AR",
    find_surface_to_measure: "Trova una superficie vicina da misurare",
    measurement_toast_note_to_guide_user: "Nota: le misure sono approssimative.",
    measurement_toast_msg_to_guide_user:
        "Per risultati ottimali, utilizzare Misura su oggetti ben definiti situati a una distanza compresa tra 0,5 e 3 metri (da 2 a 10 piedi) dal telefono.",
    having_audio_issue: "Hai un problema con l'audio?",
    remote_participant_voice_not_coming_description:
        "Sembra che tu abbia difficoltà a sentire la voce di un altro partecipante o che al momento stia riscontrando qualche tipo di problema audio.",
    workaround_action_for_remote_audio_not_coming: "<click_here> per applicare una soluzione rapida.",
    click_here_for_audio_label: "clic qui",
    measurement_copyall_msg: "Misurazioni copiate negli appunti",
    armarkup_cancelled: "Markup AR annullato",
    device_not_support_google_play_service_for_markup:
        "Il dispositivo del partecipante non supporta Google Play Service, necessario per il markup 3D",
    device_required_update_google_play_service_for_markup:
        "Il dispositivo del partecipante richiede l'aggiornamento di Google Play Service per avviare il markup 3D.",
    device_required_google_play_service_for_markup:
        "Il dispositivo del partecipante richiede l'installazione di Google Play Service per avviare il markup 3D",
    device_not_compatible_for_AR_Markup: "Dispositivo non compatibile per AR Markup",
    app_required_update_for_AR_Markup: "Aggiornamento dell'app di supporto richiesto per il markup AR",
    app_required_for_AR_Markup: "App di supporto richiesta per il markup AR",
    preparing_view_for_ar_markup: "Preparazione della vista per il markup AR...",
    AR_Markup_Lable: "Marcatura AR",
    armarkup_toast_msg_to_guide_user:
        "Per ottenere i migliori risultati, usa Markup su oggetti ben definiti situati a una distanza compresa tra 0,5 e 3 metri (da 2 a 10 piedi) dal telefono.",
    ar_live_streaming_ready_to_markup: "Streaming live AR pronto per il markup.",
    ar_markups_cleared_for_all_users: "Markup AR cancellati per tutti gli utenti.",
    ar_live_streaming_marking_stopped: "La marcatura del live streaming AR è stata interrotta",
    agent_has_ended_ar_markup_cannot_continue_without_agent: "L'agente ha terminato il markup AR. Impossibile continuare il markup AR senza l'agente",
    ar_markup_cancelled: "Markup AR annullato",
    ready_for_ar_markup: "Pronto per il markup AR",
    max_ar_arrow_limit_toast_message: "Limite di frecce raggiunto, si prega di utilizzare cancella tutto per aggiungere altro.",
    video_paused: "video messo in pausa",
    discard_label: "Scartare",
    discard_image_label: "Elimina immagine",
    save_image_label: "Salva immagine",
    go_room_call_limit_reached: "Limite chiamate Go Room raggiunto",
    circle: "Cerchio",
    arrow_with_text: "Freccia con testo",
    add_shadow_and_stroke: "Aggiungi ombra e tratto",
    font_label: "Font:",
    file_type_not_supported: "Tipo di file non supportato",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "Fare clic sul pulsante Nuova nota in basso per iniziare a prendere appunti",
    remote_user_stream_interrupted: "Flusso dell'utente remoto interrotto",
    audio_disabled_by_admin: "Audio disabilitato dall'amministratore",
    audio_disabled: "Audio disabilitato",
    dont_show_again: "Non mostrare più",
    having_an_issue_with_joining_the_call: "Hai problemi a partecipare alla chiamata?",
    to_perform_network_check: "per eseguire il controllo della rete",
    you_were_removed_from_the_call_by_the_host: "Sei stato rimosso dalla chiamata dall'host",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now:
        "L'host ti ha rimosso dalla chiamata e ora non puoi più partecipare di nuovo.",
    host_removed_you_from_the_call: "L'host ti ha rimosso dalla chiamata.",
    unable_to_join_the_call: "Impossibile partecipare alla chiamata",
    host_muted_your_microphone: "L'host ha disattivato il microfono.",
    unmute_your_microphone: "Disattiva l'audio del microfono",
    host_invites_you_to_speak_unmute_your_microphone_when_ready: "L'ospite ti invita a parlare. Disattiva l'audio del microfono quando sei pronto.",
    got_it: "Fatto",
    unmute_mic: "Disattiva microfono",
    host_turned_off_your_camera: "L'ospite ha spento la telecamera.",
    turn_your_camera_on: "Accendi la tua fotocamera",
    host_invites_you_to_turn_your_camera_on: "L'host ti invita ad accendere la telecamera.",
    turn_camera_on: "Accendi la fotocamera",
    start_sharing_your_screen: "Inizia a condividere il tuo schermo",
    host_invites_you_to_share_your_screen: "L'host ti invita a condividere il tuo schermo.",
    share_screen: "Condividi schermo",
    remove_all: "Rimuovi tutto",
    remove: "Rimuovere",
    end_call: "Termina chiamata",
    removing_all_participants_will_end_the_call: "La rimozione di tutti i partecipanti determinerà la fine della chiamata.",
    are_you_sure_you_want_to_remove_from_this_call: "Vuoi davvero rimuovere <participantName> da questa chiamata?",
    block_from_rejoining_this_call: "Impedisci <participantName> di rientrare in questa chiamata",
    turn_all_mics_off: "Disattiva tutti i microfoni",
    turn_all_cams_off: "Spegni tutte le telecamere",
    ask_to_turn_mic_on: "Chiedi di accendere il microfono",
    turn_mic_off: "Disattiva il microfono",
    turn_cam_off: "Spegni la cam",
    ask_to_turn_cam_on: "Chiedi di accendere la cam",
    ask_to_share_screen: "Chiedi di condividere lo schermo",
    having_a_video_problem: "Hai un problema con il video?",
    ios_play_pause_modal_body_text:
        "Prova a disattivare la modalità di risparmio energetico del tuo cellulare per risolvere questo problema oppure clicca sul pulsante Riproduci qui sotto per riprodurre subito il video.",
    play_video: "Riproduci video",
    camera_request_sent: "Richiesta telecamera inviata.",
    waiting_for_host_approval: "In attesa dell'approvazione dell'host.",
    microphone_request_sent: "Richiesta microfono inviata.",
    camera_request_denied: "Richiesta telecamera negata.",
    click_the_camera_icon_if_you_need_to_request_again: "Se devi effettuare un'altra richiesta, clicca sull'icona della fotocamera.",
    microphone_request_denied: "Richiesta microfono negata.",
    click_the_mic_icon_if_you_need_to_request_again: "Se devi effettuare un'altra richiesta, clicca sull'icona del microfono.",
    deny: "Negare",
    allow: "Permettere",
    user_wants_to_start_their_camera: "<ParticipantName> vuole avviare il suo <micOrCam>",
    error_in_processing_live_caption_please_retry: "Errore durante l'elaborazione dei sottotitoli in tempo reale. Riprova.",
    virtual_background: "Sfondo virtuale",
    upload_image: "Carica immagine",
    remove_image: "Rimuovi immagine",
    remove_background_image: "Rimuovi immagine di sfondo",
    are_you_sure_you_want_to_remove_background_image: "Vuoi davvero rimuovere l'immagine di sfondo?",
    unsupported_file_format: "Formato file non supportato.",
    the_maximum_file_size_supported_is_in_mb: "La dimensione massima supportata del file è <size> MB.",
    no_effect: "Nessun effetto",
    blur_background: "Sfocare lo sfondo",
    default_image: "Immagine predefinita",
    virtual_background_not_supported: "Sfondo virtuale non supportato.",
    remove_from_call: "Rimuovi dalla chiamata",
    enable_offline_mode: "Abilita modalità offline",
    offline_mode_enabled: "Modalità offline abilitata",
    your_images_will_upload_when_you_reconnect: "Le tue immagini verranno caricate quando ti riconnetterai.",
    please_keep_this_screen_open: "Si prega di tenere aperta questa schermata.",
    max_images_upload: "Massimo <count> immagini",
    remaining_image_count_label: "<remainingCount> di <totalCount> immagini",
    selected_images: "Immagini selezionate",
    offline_uploads_are_not_supported_in_private_mode: "I caricamenti offline non sono supportati in Modalità privata.",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "Per utilizzare questa funzione, passa a una scheda normale del browser.",
    guest_is_using_a_private_browser_window: "L'ospite sta utilizzando una finestra del browser privata.",
    offline_upload_mode_is_not_supported_in_this_case: "In questo caso la modalità di caricamento offline non è supportata.",
    some_images_failed_to_upload_due_to_a_network_error: "Alcune immagini non sono state caricate a causa di un errore di rete.",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "Chiudendo questa finestra modale verranno ignorate tutte le immagini selezionate durante la modalità offline.",
    live_captions_stopped: "I sottotitoli in tempo reale sono stati interrotti.",
    translate: "Tradurre",
    auto_translate: "Traduzione automatica",
    your_language: "La tua lingua",
    translation_info_text: "I messaggi degli altri partecipanti verranno tradotti automaticamente nella lingua selezionata.",
    translating: "Traduzione in corso...",
    show_original: "Mostra originale",
    show_translation: "Mostra traduzione",
    translated: "Tradotto",
    send_message_in: "Invia messaggio in",
    audio_translation: "Traduci",
    audio_translation_setup: "Traduzione Audio",
    they_speak: "Parlano",
    i_want_to_hear: "Voglio sentire",
    start_translation: "Avvia Traduzione",
    stop_translation: "Ferma Traduzione",
    starting_translation: "Avvio traduzione...",
    translation_started: "Traduzione audio avviata.",
    translation_stopped: "Traduzione audio interrotta.",
    translation_error: "Errore di traduzione. Per favore riprova.",
    translation_active: "Traduzione attiva",
    voice_type: "Voce",
    voice_female: "Femminile",
    voice_male: "Maschile",
};

export default it;
